import { getHttpService } from 'web_core_library';
import * as UnityEngine from 'web_unity_engine';
import { IExerciseBalancingConfig, UnityError } from './types';

export function createConfigService() {
  let basePath: string | undefined;
  const http = getHttpService(basePath);

  const getBasePath = () => `${basePath}`;
  const setBasePath = (newPath: string) => {
    basePath = newPath;
    http.setBaseURL(newPath);
  };

  const getUnityAppConfig = () => {
    if (!basePath) {
      throw new UnityError('Engine build path not set!');
    }
    return http.get<UnityEngine.UnityEngineAppConfig>('/Configs/AppConfig.json');
  };

  const getWorkoutBalancing = (name: string, exerciseJsonFile: string) => {
    if (!basePath) {
      throw new UnityError('Engine build path not set!');
    }
    const settingsUrl = `/Balancing/${name}/${exerciseJsonFile}`;
    return http.get<IExerciseBalancingConfig>(settingsUrl);
  };

  const getExerciseSettings = (name: string, isAssessment: boolean) => {
    if (!basePath) {
      throw new UnityError('Engine build path not set!');
    }
    const assessmentSuffix = isAssessment ? '_A' : '';
    // we have to patch the name here. don'T know why this assessment have separate folder
    const exerciseId = name === 'Symbolism' && isAssessment ? 'SymbolismAssessment' : name;
    const settingsUrl = `/Configs/${exerciseId}/Settings${assessmentSuffix}.json`;
    return http.get<UnityEngine.UnityEngineExerciseSettings>(settingsUrl);
  };

  const service = {
    getBasePath,
    setBasePath,
    getUnityAppConfig,
    getWorkoutBalancing,
    getExerciseSettings,
  };
  return service;
}

const ConfigService = createConfigService();
export default ConfigService;
